import { render, staticRenderFns } from "./subproperty-people-page.vue?vue&type=template&id=7bdb85c0&"
import script from "./subproperty-people-page.vue?vue&type=script&lang=js&"
export * from "./subproperty-people-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports